import { createSlice } from "@reduxjs/toolkit";
import {
  downloadTopRegions,
  getTopRegionsDaily,
  getTopRegionsDetails,
  getTopRegionsInsights,
  getTopRegionsInsightsCustomers,
  getTopRegionsRanking,
  getTopRegionsShare,
} from "./topRegionsV3Action";

const section = (data) => ({
  loading: false,
  error: null,
  data,
  latestRequestId: null,
});

const initialState = {
  ranking: section({ rows: [], totals: {} }),
  share: section({ rows: [], totals: {} }),
  daily: section({ rows: [], limit: null, total_regions: 0 }),
  details: section({ rows: [], totals: {} }),
  insights: section(null),
  insightsCustomers: section(null),
  download: { loading: false, error: null },
};

// Filters change faster than the sections answer: only the latest request of
// a section may write to it.
const addSectionCases = (builder, thunk, key) =>
  builder
    .addCase(thunk.pending, (state, action) => {
      state[key].loading = true;
      state[key].error = null;
      state[key].latestRequestId = action.meta.requestId;
    })
    .addCase(thunk.fulfilled, (state, action) => {
      if (action.meta.requestId !== state[key].latestRequestId) return;
      state[key].loading = false;
      state[key].data = action.payload;
    })
    .addCase(thunk.rejected, (state, action) => {
      if (action.meta.requestId !== state[key].latestRequestId) return;
      state[key].loading = false;
      state[key].data = initialState[key].data;
      state[key].error = action.payload;
    });

const topRegionsV3 = createSlice({
  name: "topRegionsV3",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    addSectionCases(builder, getTopRegionsRanking, "ranking");
    addSectionCases(builder, getTopRegionsShare, "share");
    addSectionCases(builder, getTopRegionsDaily, "daily");
    addSectionCases(builder, getTopRegionsDetails, "details");
    addSectionCases(builder, getTopRegionsInsights, "insights");
    addSectionCases(
      builder,
      getTopRegionsInsightsCustomers,
      "insightsCustomers"
    );
    builder
      .addCase(downloadTopRegions.pending, (state) => {
        state.download.loading = true;
        state.download.error = null;
      })
      .addCase(downloadTopRegions.fulfilled, (state) => {
        state.download.loading = false;
      })
      .addCase(downloadTopRegions.rejected, (state, action) => {
        state.download.loading = false;
        state.download.error = action.payload;
      });
  },
});

export default topRegionsV3.reducer;
